// React-Redux Stuff
import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { IApplicationState } from "../../../store";

// Local Redux State Stuff
import { IReport, ActionCreators } from "../../../store/rapporten/jaarverslag/AanmeldingAangemeldAfgeslotenZonderContact";
import Medewerker from "../../../entities/Medewerker";
import { IReportData } from "src/entities/reports/IReportData";

// Components
import StdRapport from "../common/StandaardRapportFull";

// Setup Title
const reportTitle = "Aangemeld en Afgesloten zonder contact";
const selectDates = true;
const selectMedewerker = true;

// Mapping Dynamic Properties
interface IPropsFromState {
    rapport: IReportData<IReport>;
    selectedUser: Medewerker;
    startDate: Date;
    endDate: Date;
}

const mapStateToProps = (state: IApplicationState): IPropsFromState => ({
    rapport: state.rapporten.jaarverslag.AanmeldingAangemeldenAfgeslotenZonderContact.Report,
    selectedUser: state.selectie.selectedMedewerker,
    startDate: state.selectie.selectedDateRange.startDate,
    endDate: state.selectie.selectedDateRange.endDate
});

// Mapping Event Dispatcher
interface IPropsFromDispatch {
    FetchReport: typeof ActionCreators.FetchReport;
    DownloadReport: typeof ActionCreators.FetchReportXlsx;
}

const mapDispatchToProps = (dispatch: Dispatch): IPropsFromDispatch => ({
    FetchReport: (userId: string, startDate: Date, endDate: Date) => dispatch(ActionCreators.FetchReport(userId, startDate, endDate)),
    DownloadReport: (userId: string, startDate: Date, endDate: Date) => dispatch(ActionCreators.FetchReportXlsx(userId, startDate, endDate))
});

// Setup Report
type AllProps = IPropsFromState & IPropsFromDispatch;

class Rapport extends React.Component<AllProps> {
    constructor(props: AllProps) {
        super(props);
    }

    public render() {
        return (
            <StdRapport
                title={reportTitle}
                selectDate={selectDates}
                selectMedewerker={selectMedewerker}
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                selectedUser={this.props.selectedUser}
                rapport={this.props.rapport}
                FetchReport={this.props.FetchReport}
                FetchReportXlsx={this.props.DownloadReport}
                columns={[
                    {
                        Header: "Personalia",
                        columns: [
                            { Header: "Medewerker", accessor: "medewerker" },
                            { Header: "Client", accessor: "naam" }
                        ]
                    },
                    {
                        Header: "Aanmelding",
                        columns: [
                            { Header: "Datum", accessor: "datumAanmelding", Cell: (p: any) => <span>{p.value == null ? "" : new Date(p.value).toLocaleDateString()}</span> },
                            { Header: "Reden Nooit Opgestart", accessor: "redenNooitOpgestart" }
                        ]
                    }
                ]}
            />
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Rapport);